export default __webpack_public_path__ + "static/media/sponsor-banner-m.b820a45b.webp";